import * as Sentry from '@sentry/react';
import { sentryEnabled } from './instrument/sentry';
import { lazyWithRetry } from 'core/utils/lazyWithRetry';

// Lazy load public route components for better code splitting
const FeedbackLoopPage = lazyWithRetry(() =>
    import('modules/feedback-loop/pages/FeedbackLoopPage').then((module) => ({
        default: module.FeedbackLoopPage,
    }))
);
const LoginPage = lazyWithRetry(() =>
    import('modules/login/pages/LoginPage').then((module) => ({
        default: module.LoginPage,
    }))
);
const SurveyPage = lazyWithRetry(() =>
    import('modules/pulse-answering/pages/SurveyPage').then((module) => ({
        default: module.SurveyPage,
    }))
);
const ResetPasswordPage = lazyWithRetry(() =>
    import('modules/resetpassword/pages/ResetPasswordPage').then((module) => ({
        default: module.ResetPasswordPage,
    }))
);
const DataProtectionPolicy = lazyWithRetry(() =>
    import('./modules/help-feedback/pages/DataProtectionPolicy').then(
        (module) => ({ default: module.DataProtectionPolicy })
    )
);
const SetupAccount = lazyWithRetry(() =>
    import('./modules/login/pages/SetupAccount').then((module) => ({
        default: module.SetupAccount,
    }))
);
const RequestResetPasswordPage = lazyWithRetry(() =>
    import('./modules/resetpassword/pages/RequestPassowrdPage').then(
        (module) => ({ default: module.RequestResetPasswordPage })
    )
);
const SuccessRequestPasswordPage = lazyWithRetry(() =>
    import('./modules/resetpassword/pages/SuccesRequestPasswordPage').then(
        (module) => ({ default: module.SuccessRequestPasswordPage })
    )
);
const SuccessNewPasswordPage = lazyWithRetry(() =>
    import('./modules/resetpassword/pages/SuccessNewPasswordPage').then(
        (module) => ({ default: module.SuccessNewPasswordPage })
    )
);

// Lazy load Layout to avoid loading date-pickers and other chunks on login
const Layout = lazyWithRetry(() =>
    import('./core/components/Layout').then((module) => ({
        default: module.Layout,
    }))
);

// Keep these as static imports since they're needed immediately
import { PrivateRoute } from 'modules/login/components/privateRoute/PrivateRoute';
import { ROUTES } from 'modules/navigation/enums/routes.enum';
import { BrowserRouter, Route, Routes } from 'react-router';
import './App.scss';

const AppContainer = () => (
    <BrowserRouter>
        <Routes>
            <Route
                path={ROUTES.LOGIN}
                element={
                    <main role="main" id="main-content">
                        <LoginPage />
                    </main>
                }
            />
            <Route
                path={ROUTES.RESET_PASSWORD}
                element={
                    <main role="main" id="main-content">
                        <RequestResetPasswordPage />
                    </main>
                }
            />
            <Route
                path={ROUTES.SUCCESS_PASSWORD}
                element={
                    <main role="main" id="main-content">
                        <SuccessNewPasswordPage />
                    </main>
                }
            />
            <Route
                path={ROUTES.SUCCESS_REQUEST_PASSWORD}
                element={
                    <main role="main" id="main-content">
                        <SuccessRequestPasswordPage />
                    </main>
                }
            />
            <Route
                path={ROUTES.RESET_PASSWORD_HASH}
                element={
                    <main role="main" id="main-content">
                        <ResetPasswordPage />
                    </main>
                }
            />
            <Route
                path={ROUTES.DATA_PROTECTION_POLICY}
                element={
                    <main role="main" id="main-content">
                        <DataProtectionPolicy />
                    </main>
                }
            />
            <Route
                path={ROUTES.ACTIVATE_ACCOUNT}
                element={
                    <main role="main" id="main-content">
                        <SetupAccount />
                    </main>
                }
            />
            <Route
                path={ROUTES.SURVEY}
                element={
                    <main role="main" id="main-content">
                        <SurveyPage />
                    </main>
                }
            />
            {/* TODO: fix these routes */}
            {/* <Route
            path={ROUTES.OLD_SURVEY}
            render={(props) => (
                <Navigate
                    to={pathBuilder(
                        ROUTES.SURVEY,
                        ':id',
                        props.match.params.id
                    )}
                />
            )}
        /> */}
            {/* <Navigate from={`/${ROUTES.OLD_SURVEY}`} to={ROUTES.OLD_SURVEY} /> */}
            <Route
                path={ROUTES.FEEDBACK}
                element={
                    <main role="main" id="main-content">
                        <FeedbackLoopPage />
                    </main>
                }
            />
            {/* <Route path={ROUTES.TBD} element={<ToBeDefined />} /> */}
            <Route
                path="*"
                element={
                    <PrivateRoute>
                        <Layout />
                    </PrivateRoute>
                }
            />
            {/* <PrivateRoute path="" component={Layout} /> */}
        </Routes>
    </BrowserRouter>
);

export const App = sentryEnabled
    ? Sentry.withProfiler(AppContainer)
    : AppContainer;
